import ContentBox from "./ContentBox";
import React from "react";

const LoadingPage = () => {
    return (
        <ContentBox className="loading-content-box">
            <div className='spinner-container'>
                <div className="spinner" />
            </div>
        </ContentBox>
    )
};

export default LoadingPage;